export enum ImageSizeType {
  HEIGHT = 'height',
  WIDTH = 'width',
}

export const MIN_IMAGE_WIDTH = 1;
